import { render, staticRenderFns } from "./Tier.vue?vue&type=template&id=59f2d86e&scoped=true&"
import script from "./Tier.vue?vue&type=script&lang=js&"
export * from "./Tier.vue?vue&type=script&lang=js&"
import style0 from "./Tier.vue?vue&type=style&index=0&id=59f2d86e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f2d86e",
  null
  
)

export default component.exports